import { Box, Button, Divider, Drawer, IconButton, Tooltip, Typography, useTheme } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import React, { useState } from 'react';
import { useSnackbar } from 'notistack';
import CustomModal from '../../CustomModal';
import Iconify from '../../Iconify';
import Image from '../../Image';
import { openModal } from '../../../redux/slices/profileSlice';
import useResponsive from '../../../hooks/useResponsive';
import NonRootHeader from '../../../layouts/dashboard/header/NonRootHeader';
import BirthdayDialog from './BirthdayDialog';
import MobileNumberDialog from './MobileNumber';
import useLocales from '../../../hooks/useLocales';
import CopyPNG from '../../../assets/profile/coppy.png';
import { isSafariOrIOS } from '../../../utils/isSafariOrIOS';

const EditProfileDialog = ({ handleClose, handleOpen }) => {
  const theme = useTheme();
  const { translate } = useLocales();
  const [openBirthday, setOpenBirthday] = useState(false);
  const [openMobileNumber, setOpenMobileNumber] = useState(false);
  const isDesktop = useResponsive('up', 'lg');
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { memberInfo } = useSelector((x) => ({
    ...x.lookup,
  }));

  const hasDob = !!memberInfo?.dob;

  return (
    <>
      {isDesktop && (
        <CustomModal hasClose={true} maxWidth={'xs'} open={handleOpen} onClose={handleClose}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              pt: 2,
              px: 5,
              pb: 5,
              width: '100%',
            }}
          >
            <Typography variant="subtitle1" fontWeight={600} textAlign="center" mb={1}>
              {translate('edit_profile')}
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: '32px' }}>
              <Typography fontWeight={600}>{translate('uuid')}</Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography
                  sx={{
                    maxWidth: 160,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                  color="text.secondary"
                >
                  {memberInfo?.uuid}
                </Typography>

                <Tooltip title="Copy">
                  <Image
                    src={CopyPNG}
                    sx={{ width: '20px', height: '20px', cursor: 'pointer' }}
                    onClick={() => {
                      navigator.clipboard.writeText(`${memberInfo?.uuid}`);
                      enqueueSnackbar('UUID copied to clipboard', { variant: 'success' });
                    }}
                  />
                </Tooltip>
              </Box>
            </Box>

            <Divider
              sx={{
                borderColor: '#ccc',
              }}
            />

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography fontWeight={600}>{translate('name')}</Typography>
              <Typography color="text.secondary"> {memberInfo?.fullName}</Typography>
            </Box>

            <Divider
              sx={{
                borderColor: '#ccc',
              }}
            />

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: hasDob ? 'default' : 'pointer',
                opacity: 1,
              }}
              onClick={() => {
                if (hasDob) return;
                dispatch(
                  openModal({
                    view: 'birthday',
                    data: memberInfo?.dob,
                  })
                );
              }}
            >
              <Typography fontWeight={600}>{translate('birthday')}</Typography>
              <Typography color="text.secondary">
                {memberInfo?.dob ? `${memberInfo.dob}` : `${translate('set_now')} >`}
              </Typography>
            </Box>

            <Divider
              sx={{
                borderColor: '#ccc',
              }}
            />

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography fontWeight={600}>{translate('currency')}</Typography>
              <Typography color="text.secondary">{memberInfo?.currency}</Typography>
            </Box>

            <Divider
              sx={{
                borderColor: '#ccc',
              }}
            />

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography fontWeight={600}>{translate('country')}</Typography>
              <Typography color="text.secondary">{translate('malaysia')}</Typography>
            </Box>

            <Divider
              sx={{
                borderColor: '#ccc',
              }}
            />

            <Box
              sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              // onClick={() => {
              //   dispatch(
              //     openModal({
              //       view: 'mobile-number',
              //     })
              //   );
              // }}
            >
              <Typography fontWeight={600}>{translate('phone_number')}</Typography>
              <Typography color="text.secondary">{memberInfo?.phoneNumber}</Typography>
            </Box>

            <Divider
              sx={{
                borderColor: '#ccc',
              }}
            />
            {/* 
            <Box
              sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
              onClick={() => {}}
            >
              <Typography fontWeight={600}>{translate('email')}</Typography>
              <Typography color="text.secondary">{translate('set_now')} &gt;</Typography>
            </Box> */}

            {/* <Divider
              sx={{
                borderColor: '#ccc',
              }}
            /> */}

            <Box
              sx={{ mb: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
              onClick={() => {
                dispatch(
                  openModal({
                    view: 'change-password',
                  })
                );
              }}
            >
              <Typography fontWeight={600}>{translate('login_password')}</Typography>
              <Typography color="text.secondary">{translate('change')} &gt;</Typography>
            </Box>
          </Box>
        </CustomModal>
      )}

      {!isDesktop && (
        <Drawer
          anchor="right"
          maxWidth="xs"
          open={handleOpen}
          PaperProps={{
            sx: {
              width: '100%',
            },
          }}
        >
          <Box sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
            <IconButton onClick={handleClose} sx={{ position: 'absolute', left: 8 }}>
              <Iconify icon="material-symbols:arrow-back-ios-new-rounded" />
            </IconButton>
            <Typography variant="h6" fontWeight={700}>
              {translate('edit_profile')}
            </Typography>
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              p: 2,
              gap: 2,
              height: '100%',
              background: isSafariOrIOS ? theme.palette.gradients.theme3Ios : theme.palette.gradients.theme3,
            }}
          >
            <Box
              sx={{
                background: '#fff',
                borderRadius: 2,
                p: 2,
              }}
            >
              {/* UID */}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  pb: 1.5,
                }}
              >
                <Typography fontWeight={600}>{translate('uuid')}</Typography>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography
                    sx={{
                      maxWidth: 160,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                    color="text.secondary"
                  >
                    {memberInfo?.uuid}
                  </Typography>

                  <Image
                    src={CopyPNG}
                    sx={{ width: '20px', height: '20px' }}
                    onClick={() => {
                      navigator.clipboard.writeText(`${memberInfo?.uuid}`);
                      enqueueSnackbar('UUID copied to clipboard', { variant: 'success' });
                    }}
                  />

                  {/* <IconButton size="small" onClick={() => navigator.clipboard.writeText(`${memberInfo?.uuid}`)}>
                    <Iconify icon="mdi:content-copy" width={18} />
                  </IconButton> */}
                </Box>
              </Box>

              <Divider />

              {/* Name */}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  py: 1.5,
                }}
              >
                <Typography fontWeight={600}>{translate('name')}</Typography>
                <Typography color="text.secondary">{memberInfo?.fullName}</Typography>
              </Box>

              <Divider />

              {/* Birthday */}
              <Box
                onClick={!hasDob ? () => setOpenBirthday(true) : undefined}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  py: 1.5,
                  cursor: hasDob ? 'default' : 'pointer',
                  opacity: 1,
                }}
              >
                <Typography fontWeight={600}>{translate('birthday')}</Typography>
                <Typography color="text.secondary">
                  {memberInfo?.dob ? memberInfo.dob : `${translate('set_now')} >`}
                </Typography>
              </Box>

              <Divider />

              {/* Currency */}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  py: 1.5,
                }}
              >
                <Typography fontWeight={600}>{translate('currency')}</Typography>
                <Typography color="text.secondary">{memberInfo?.currency}</Typography>
              </Box>

              <Divider />

              {/* Country */}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  pt: 1.5,
                }}
              >
                <Typography fontWeight={600}>{translate('country')}</Typography>
                <Typography color="text.secondary">{translate('malaysia')}</Typography>
              </Box>
            </Box>

            <Box
              sx={{
                background: '#fff',
                borderRadius: 2,
                p: 2,
              }}
            >
              <Box
                sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                // onClick={() => setOpenMobileNumber(true)}
              >
                <Typography fontWeight={600}>{translate('phone_number')}</Typography>
                <Typography color="text.secondary">{memberInfo?.phoneNumber}</Typography>
              </Box>
            </Box>

            <Box
              sx={{
                background: '#fff',
                borderRadius: 2,
                p: 2,
              }}
            >
              <Box
                sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                onClick={() => {
                  dispatch(
                    openModal({
                      view: 'change-password',
                    })
                  );
                }}
              >
                <Typography fontWeight={600}>{translate('login_password')}</Typography>
                <Typography color="text.secondary">{translate('change')} &gt;</Typography>
              </Box>
            </Box>
          </Box>
        </Drawer>
      )}

      <MobileNumberDialog handleOpen={openMobileNumber} handleClose={() => setOpenMobileNumber(false)} />
      <BirthdayDialog handleOpen={openBirthday} handleClose={() => setOpenBirthday(false)} />
    </>
  );
};

export default EditProfileDialog;
